import { type RefObject } from "@hopper-ui/components";
import { useEffect, useRef } from "react";

// Copied from https://github.com/react-restart/hooks/blob/master/src/useCommittedRef.ts.
export function useCommittedRef<T>(value: T): RefObject<T | null> {
    const ref = useRef(value);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref;
}
